import * as React from 'react'
import { connect } from 'react-redux'

import { Button, TYPE } from 'components/Button'
import { TabItem, Tabs } from 'components/Tabs'
import { SRPRS } from 'Icon/srprs'

import Content from '../../pages/shared/content'

import { Theme } from '../../data/models/funnelOrder/theme'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import MultiCityTooltip from '../tooltips/multiCityTooltip'

interface MultiLinkSwitchProps {
  theme: Theme
  country: SiteCountry

  onSetRedirect(redirect: string): void
}

enum MultiType {
  one,
  multi,
}

const MultiLinkSwitch: React.FC<MultiLinkSwitchProps> = props => {
  const iconSolo =
    props.theme === Theme.fly || props.theme === Theme.multiFly
      ? SRPRS.aeroplaneNoPlus
      : SRPRS.carNoPlus
  const iconMulti =
    props.theme === Theme.fly || props.theme === Theme.multiFly
      ? SRPRS.aeroplanePlus
      : SRPRS.carPlus
  return [SiteCountry.nl, SiteCountry.be].includes(props.country) ? (
    <>
      <Tabs>
        <TabItem
          label={
            <Content addNode contentKey="a-city">
              A city
            </Content>
          }
          active={props.theme === Theme.fly || props.theme === Theme.drive}
          onClick={() => {
            if (
              props.theme === Theme.multiFly ||
              props.theme === Theme.multiDrive
            ) {
              props.onSetRedirect(getSwitchName(props.theme, MultiType.one))
            }
          }}
        >
          <MultiCityTooltip contentKey="a-city-info" icon={iconSolo}>
            <Button type={TYPE.info} />
          </MultiCityTooltip>
        </TabItem>
        {/* <div style={{alignSelf: "flex-start"}}>
                <MultiCityTrigger/>
            </div> */}
        <TabItem
          label={
            <Content addNode contentKey="multi-city">
              Multi City
            </Content>
          }
          active={
            props.theme === Theme.multiFly || props.theme === Theme.multiDrive
          }
          onClick={() => {
            if (props.theme === Theme.fly || props.theme === Theme.drive) {
              props.onSetRedirect(getSwitchName(props.theme, MultiType.multi))
            }
          }}
        >
          <MultiCityTooltip contentKey="multi-city-info" icon={iconMulti}>
            <Button type={TYPE.info} />
          </MultiCityTooltip>
        </TabItem>
      </Tabs>
    </>
  ) : null
}

export default connect((state: AppState) => ({
  country: state.locale.country,
  theme: state.funnelOrder.theme,
}))(MultiLinkSwitch)

function getSwitchName(theme: Theme, type: MultiType) {
  switch (theme) {
    case Theme.fly:
    case Theme.multiFly:
    default:
      return type === MultiType.one ? 'flycustomise' : 'multiflycustomise'
    case Theme.drive:
    case Theme.multiDrive:
      return type === MultiType.one ? 'drivecustomise' : 'multidrivecustomise'
  }
}
